import { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SET_OFFERS, SET_OFFER_HISTORY, SET_PURCHASES, SET_RESPONSES } from '../../redux/actions/eth';
import { listenForOffers, listenForResponses, listenForPurchases, offerHistory } from '../../util/metamask';

const OfferWatcher = () => {

    const dispatch = useDispatch(),
    accounts = useSelector( state => state.eth.accounts ),
    [ watching, setWatching ] = useState([]);

    /**
     * @name updateOffer
     * @function
     * @description Sends the offer data back to the reducer
     * @param {array|object} payload Offer(s) to be added
     */
    const updateOffer = useCallback( payload => {
        dispatch({ type: SET_OFFERS, payload });
    }, [ dispatch ]);

    /**
     * @name updatePurchase
     * @function
     * @description Sends the response data back to the reducer
     * @param {array|object} payload Offer(s) to be added
     */
    const updatePurchase = useCallback( payload => {
        dispatch({ type: SET_PURCHASES, payload });
    }, [ dispatch ]);

    /**
     * @name updateResponse
     * @function
     * @description Sends the response data back to the reducer
     * @param {array|object} payload Offer(s) to be added
     */
    const updateResponse = useCallback( payload => {
        dispatch({ type: SET_RESPONSES, payload });
    }, [ dispatch ]);

    /**
     * @name check
     * @function
     * @description Checks the offer amount
     */
    const check = useCallback( async () => {
        
        const { selectedAddress } = window.ethereum;

        if( !watching.includes( selectedAddress ) ){

            setWatching([ ...watching, selectedAddress ]);
            const sell = await offerHistory({ seller: selectedAddress }),
            buy = await offerHistory({ buyer: selectedAddress });

            // send historic offers
            dispatch({ type: SET_OFFER_HISTORY, payload: { sell, buy, address: selectedAddress } });

            // listen for new offers
            listenForOffers( updateOffer, selectedAddress, 'sell', { seller: selectedAddress });
            listenForOffers( updateOffer, selectedAddress, 'buy', { buyer: selectedAddress });
            listenForResponses( updateResponse, selectedAddress, 'sell', { seller: selectedAddress });
            listenForResponses( updateResponse, selectedAddress, 'buy', { buyer: selectedAddress });
            listenForPurchases( updatePurchase, selectedAddress, 'sell', { seller: selectedAddress });
            listenForPurchases( updatePurchase, selectedAddress, 'buy', { buyer: selectedAddress });
        }
        
    }, [ dispatch, updateOffer, updateResponse, updatePurchase, setWatching, watching ]);

    // initialize the listener
    useEffect(() => {
        if( accounts[ 0 ] ) check();
    }, [ accounts, check ]);

    return null;

}

export default OfferWatcher;